import { axiosInstance } from "@/helper/axios-instance";
import { DataAwareResponse, User } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useUserCreation() {
  return useMutationWithValidation({
    mutationFn: async (newUser: Partial<User>) => {
      const response = await axiosInstance({
        method: "PUT",
        url: `SystemUser/insert`,
        data: newUser,
      });

      return response.data as DataAwareResponse<User>;
    },
    retry: 2,
  });
}
